const AppLoader = () => {
    return (  <div class="app-loader">
    <img src={"/external_assets/img/motor_logo.png"} alt=""/>
  </div> );
}
 
export default AppLoader;